<script src="mer-accordion/mer-accordion.component.ts"></script>
<div style="display: flex;gap:24px;padding: 8px; height: 100vh;">
  @if (subscriptionsEditable() != null) {
    <div data-testid="dropIn" class="card" style="flex: 1">
      <app-mer-accordion [data]="subscriptionsEditable()['dropIn']" subscriptionName="Drop-in"></app-mer-accordion>
    </div>
    <div data-testid="energy" class="card" style="flex: 1">
      <app-mer-accordion [data]="subscriptionsEditable()['energy']" subscriptionName="Energy"></app-mer-accordion>
    </div>
    <div data-testid="flexible" class="card" style="flex: 1">
      <app-mer-accordion [data]="subscriptionsEditable()['flexible']" subscriptionName="Flexible"></app-mer-accordion>
    </div>
  }
</div>
<div
  style="position: sticky;text-align:center;bottom: 0;left: 0;right: 0; background: white;padding: 16px;box-shadow: 0 -4px 22px 0 rgba(2,8,24,0.25);">
  <button (click)="saveData()" class=" primary-button" data-testid="saveButton">Update data</button>
</div>
